import {
  SESSION_STORAGE_UNAVAILABLE,
  deleteCookie,
  getCookie,
  getSessionItem,
  isBrowser,
  newUuid,
  setCookie,
  setSessionItem,
} from "./browser";

export const ANONYMOUS_ID_COOKIE = "ml_anonymous_id";
export const ANONYMOUS_ID_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 12 months
const ANONYMOUS_LINKED_KEY = "ml_anon_linked";
const LINKED_ANONYMOUS_ID_KEY = "ml_linked_anonymous_id";

export type AnonymousIdResult = {
  anonymousId: string;
  created: boolean;
};

export function getAnonymousId(): AnonymousIdResult {
  if (!isBrowser()) {
    return { anonymousId: "", created: false };
  }

  const existing = getCookie(ANONYMOUS_ID_COOKIE)?.trim();
  if (existing) {
    return { anonymousId: existing, created: false };
  }

  const anonymousId = newUuid();
  setCookie(ANONYMOUS_ID_COOKIE, anonymousId, ANONYMOUS_ID_MAX_AGE_SECONDS);
  return { anonymousId, created: true };
}

export function readAnonymousId(): string | null {
  const existing = getCookie(ANONYMOUS_ID_COOKIE)?.trim();
  return existing || null;
}

export function clearAnonymousId(): void {
  deleteCookie(ANONYMOUS_ID_COOKIE);
}

/** This tab already sent the current browser id together with an account. */
export function isAnonymousLinkActive(): boolean {
  return getSessionItem(ANONYMOUS_LINKED_KEY) === "1";
}

export function markAnonymousLinked(anonymousId: string): void {
  const cleaned = anonymousId.trim();
  if (cleaned) {
    setSessionItem(LINKED_ANONYMOUS_ID_KEY, cleaned);
  }
  setSessionItem(ANONYMOUS_LINKED_KEY, "1");
}

/** Browser id already sent with this account. Checkout still needs it; later events do not. */
export function readLinkedAnonymousId(): string | null {
  const value = getSessionItem(LINKED_ANONYMOUS_ID_KEY);
  if (!value || value === SESSION_STORAGE_UNAVAILABLE) return null;
  const cleaned = value.trim();
  return cleaned || null;
}

export function clearAnonymousLink(): void {
  if (!isBrowser()) return;
  try {
    window.sessionStorage.removeItem(ANONYMOUS_LINKED_KEY);
    window.sessionStorage.removeItem(LINKED_ANONYMOUS_ID_KEY);
  } catch {
    // sessionStorage may be disabled.
  }
}
